// @flow
import { authActions } from './authActionCreator';

const initUserState = null;

const userReducer = (state: ?Object = initUserState, action: Object) => {
  let newState;
  switch (action.type) {
    case authActions.SET_USER_PROFILE: {
      newState = action.payload;
      break;
    }
    default: {
      newState = state;
    }
  }
  return newState;
};

export default userReducer;
